import React from 'react';
import Modal from 'react-responsive-modal';
import './ImportGifs.scss';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Observer, GLOBAL_EVENT, GifImports } from '../../../Observer';
import { AddImage, ImageData } from '../../../../../Redux/Actions/Atlas/images.action';
import { connect } from 'react-redux';
import generateId from '../../../../../utils/generateId';

class ImportGifs extends React.Component<
    { AddImage: (Images: Array<ImageData>) => {} },
    { open: boolean; gifs: GifImports }
> {
    default_gifs: GifImports = {
        width: 0,
        height: 0,
        name: '',
        srcs: [],
    };
    constructor(props: any) {
        super(props);
        this.state = {
            open: false,
            gifs: this.default_gifs,
        };
        this.handleAddGif = this.handleAddGif.bind(this);

        Observer.on(GLOBAL_EVENT.IMPORT_GIF, (gifs: GifImports) => {
            this.setState({
                ...this.state,
                open: true,
                gifs,
            });
        });
    }

    handleCloseModal = () => {
        this.setState({
            ...this.state,
            open: false,
            gifs: this.default_gifs,
        });
    };

    handleAddGif() {
        const ImagesData: ImageData[] = this.state.gifs.srcs.map(
            (src, index: number): ImageData => {
                return {
                    id: generateId(),
                    name: `${this.state.gifs.name}_${index}`,
                    width: this.state.gifs.width,
                    height: this.state.gifs.height,
                    size: 0,
                    active: false,
                    changeName: false,
                    src: src,
                    origin: {
                        x: 0.5,
                        y: 0.5,
                    },
                };
            }
        );

        this.props.AddImage(ImagesData);
        this.handleCloseModal();
    }

    render() {
        return (
            <Modal
                open={this.state.open}
                onClose={this.handleCloseModal}
                closeOnOverlayClick={false}
                center
                classNames={{ outline: '10px solid red' }}
                styles={{ marginTop: '1000px' }}
            >
                <h3 className="noselect mb-3">Import Gif options</h3>
                <div className="noselect">
                    <div className="import-gif-container--center pb-2">
                        {this.state.gifs.srcs.length >= 1 && (
                            <PerfectScrollbar options={{ suppressScrollX: true }} className={`p-3`}>
                                <div className="grid-container-gif pb-4">
                                    {this.state.gifs.srcs.map((src: string, i: number) => {
                                        return (
                                            <div className="grid-item-gif" key={i}>
                                                <img src={src} alt="gif_image" className="w-100" />
                                            </div>
                                        );
                                    })}
                                </div>
                            </PerfectScrollbar>
                        )}
                    </div>
                    <div className="import-gif--buttons mt-2">
                        <button id="btn-accept" className="ml-1" onClick={this.handleAddGif}>
                            Accept
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapDispatchToProps = {
    AddImage,
};

export default connect(null, mapDispatchToProps)(ImportGifs);
